import { render, staticRenderFns } from "./ItemListOption.vue?vue&type=template&id=622e4996&lang=pug"
import script from "./ItemListOption.vue?vue&type=script&lang=js"
export * from "./ItemListOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports